import { http } from './http';

export type PatreonAuthUrlResponse = {
  url: string;
};

export type PatreonIsAuthResponse = {
  isAuth: boolean;
};

// GET api/Patreon/url-auth
export function getPatreonAuthUrl() {
  return http.get<PatreonAuthUrlResponse>('api/Patreon/url-auth');
}

// GET api/Patreon/callback?code=...&state=...
export function patreonCallback(code: string, state: string) {
  return http.get(`api/Patreon/callback?code=${code}&state=${state}`);
}

// GET api/Patreon/is-auth
export function patreonIsAuth() {
  return http.get<PatreonIsAuthResponse>('api/Patreon/is-auth');
}